












































import gql from 'graphql-tag'
import { Component, Mixins } from 'vue-property-decorator'

import { logEvent } from '@/common'
import AppCoupon from '@/components/AppCoupon.vue'
import AppUrlLink from '@/components/AppUrlLink.vue'
import ItemTile from '@/components/ItemTile.vue'
import { analytics } from '@/firebase'
import { ITEM_TILE_FRAGMENT } from '@/gql/item'
import { Common, ScrollToFetch } from '@/mixins'

@Component({
  components: {
    AppCoupon,
    AppUrlLink,
    ItemTile
  },
  metaInfo () {
    const banner = (this as any).banner
    return {
      meta: [
        { name: 'description', content: banner.detailDescription },
        { property: 'og:title', content: `${banner.detailTitle} - 페퍼로니` },
        {
          property: 'og:image',
          content: banner.sections && banner.sections.length && banner.sections[0].medias.length && (this as any).imgSrcResized(banner.sections[0].medias[0].path, '400')
        },
        { property: 'og:url', content: location.origin + location.pathname }
      ]
    }
  },
  apollo: {
    banner: {
      query: gql`query banner($bannerId: ID!) {
        banner(bannerId: $bannerId) {
          id
          isActive
          detailTitle
          detailDescription
        }
      }`,
      variables () {
        return {
          bannerId: this.$route.params.id
        }
      },
      async result ({ data: { banner } }: { data: { banner: {
        id: string;
        isActive: boolean;
        detailTitle: string;
      }; }; }) {
        if (!banner.isActive) {
          await this.routerReplace('/not-found')
        }
        document.title = `${banner.detailTitle} - 페퍼로니`
        await logEvent('select_content', { item_id: banner.id, content_type: 'banner' })
        if (analytics) {
          await this.logAppsflyerEvent('af_content_view', {
            af_content_id: banner.id,
            af_content_type: 'banner'
          })
        }
      }
    },
    bannerSectionConnection: {
      query: gql`query bannerSectionConnection($bannerId: ID!, $after: String) {
        bannerSectionConnection(bannerId: $bannerId, after: $after) {
          cursor
          hasNextPage
          sections {
            id
            type
            description
            couponDownloadable
            coupon {
              id
              name
              description
              type
              param1
              param2
              startedAt
              expiredAt
              createdAt
              isActive
              downloadsPerUser
              availableDaysAfterDownload
              applicableShoppingMallNames
            }
            couponBackgroundColor {
              r
              g
              b
              a
            }
            couponTextColor {
              r
              g
              b
              a
            }
            items {
              ...ItemTileFragment
            }
            feeds {
              id
            }
            medias {
              id
              type
              path
              url
            }
          }
        }
      }
      ${ITEM_TILE_FRAGMENT}`,
      variables () { return { bannerId: this.$route.params.id } },
      async result ({ data }: {
        data: {
          bannerSectionConnection: {
            sections: {
              feeds: {
                id: string;
              }[];
            }[];
          };
        };
      }) {
        if (this.sentUserFeedReaction) return
        this.sentUserFeedReaction = true

        const fetchMore = window.onscroll as any
        fetchMore()

        const feedIds = data.bannerSectionConnection.sections.flatMap(section => section.feeds).map(feed => feed.id)
        await Promise.all(feedIds.map(feedId => this.$apollo.mutate({
          mutation: gql`mutation ($input: UserFeedReactionInput!) {
            sendUserFeedReaction(input: $input) {
              id
            }
          }`,
          variables: {
            input: {
              feedId,
              retentions: 1,
              openItem: false,
              openContents: false,
              playedAt: 0,
              reactedItemId: -1,
              reactedFeedId: -1
            }
          }
        })))
      }
    }
  }
})
export default class extends Mixins(Common, ScrollToFetch) {
  banner = {
    id: '',
    detailTitle: '',
    detailDescription: '',
    items: []
  }

  bannerSectionConnection = { sections: [] }
  sentUserFeedReaction = false

  async mounted () {
    this.addScrollListener('bannerSectionConnection', 'sections')
  }

  async onClickShare () {
    await this.shareLocation(`banner-${this.banner.id}`)
  }
}
